import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import { fetchTransactionsBySeller } from '../../../State/seller/transactionSlice';
import { useAppDispatch, useAppSelector } from '../../../State/Store';
import { formatDate } from '../../../utils/formatDate';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));




export default function TransactionTable() {
  const dispatch = useAppDispatch()
  const {transaction}=useAppSelector(store=>store)

  useEffect(() => {  
    dispatch(fetchTransactionsBySeller())
  },[dispatch])
  if (!transaction.transactions.length) {
    return <div>
      <h1 className='font-bold mb-5 text-xl'>All Transactions</h1>
      <h1>You have no transaction</h1>
    </div>;
  }
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Date</StyledTableCell>
            
            <StyledTableCell align="right">Customer Details</StyledTableCell>
            <StyledTableCell align="right">Order</StyledTableCell>
            <StyledTableCell align="right">Amount €</StyledTableCell>
           
          </TableRow>
        </TableHead>
        <TableBody>
          {transaction.transactions.map((item) => (
            <StyledTableRow key={item.id}>
              <StyledTableCell component="th" scope="row">
                {formatDate(item.createdDate)}
              </StyledTableCell>
             
              <StyledTableCell align="right">{item.userEmail}</StyledTableCell>
              <StyledTableCell align="right">{item.orderId}</StyledTableCell>
              <StyledTableCell align="right">{item.sellingPrice} €</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}